import React from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody } from "reactstrap";
import "./BonusTermsModal.css";

export const BonusTermsModal = ({ isOpen, setIsOpen }) => {
  const { t } = useTranslation();
  return (
    <>
      <Modal isOpen={isOpen} className="bonus-terms-modal" toggle={() => setIsOpen(false)}>
        <div className="modal-close-btn" onClick={() => setIsOpen(false)}>
          <i className="far fa-times-circle"></i>
        </div>
        <ModalBody className="bonus-terms-body">
          <div className="bouns-terms-content">
            <span className="bonus-terms-modal-title ">{t("BONUS TERMS AND CONDITIONS")}</span>
            <div className="bonus-terms-container d-flex flex-column">
              <span className="title">{t("Bonuses - General Terms")}</span>
              <p>
                {t("All and any bonuses are available to players from any countries except for Sweden (SE).")}
                <br /> {t("Players from Finland aren't eligible for any deposit-based bonuses.")}
              </p>
              <p>
                1b.
                {t(
                  "The maximum win restriction persists after the completion of the wagering requirement. The maximum you will ever be able to withdraw from play with funds associated with a nodeposit bonus is 50 EUR, 50 USD, 500 NOK, 75 CAD, 75 AUD, 200 PLN, 75 NZD, 1,200 CZK, 6,000 JPY. To submit a withdrawal request, the account must be fully verified and a minimum deposit must be made."
                )}
              </p>
              <p>
                1c.
                {t(
                  "The maximum winnings that will be paid out resulting from a cashback bonus, comp points bonus, tournament bonus, any deposit bonus except welcome bonus, personal VIP bonus or the weekly bonus will be 10,000"
                )}
                <br />
                {t("EUR/USD/CAD/AUD, 100,000 NOK, 50,000 PLN, 250,000 CZK, 1,200,000 JPY.")}
                <br /> {t("Please note that any amount in excess will be forfeited priorto requesting a withdrawal.")}
                <br /> {t("Time-frame set for examination for each specific case is set up to 14 working days.")}
              </p>
              <p>1d. {t("Only one bonus is awarded per person (e-mail/browser/device/IP address), unless stated otherwise.")}</p>
              <p>
                1e.
                {t(
                  `While you have active bonus, maximum bet for all game types (slots, live games, table games, scratch, action games) is 5 EUR / 5 USD / 50 NOK / 6.5 CAD / 6.5 AUD / 6.5 NZD / 20 PLN /125 CZK, 600 JPY (Unless stated otherwise in special terms for the bonus). Purchasing any game features (including but not limited to respins) will add to your bet amount. If the player exceeds the maximum bet when the bonus is active, ${process.env.REACT_APP_BRAND_NAME} reserves the right to confiscate the winnings.`
                )}
              </p>
              <p>
                1f.
                {t(
                  "To get any deposit bonus, the player needs to make a deposit of at least EUR 20, USD 20, 200 NOK, 25 CAD, 25 AUD, 25 NZD, 100 PLN, 500 CZK, 2,400 JPY."
                )}
              </p>
              <p>
                1g.
                {t(
                  "To activate any deposit bonus, the player must use the bonus code provided in the bonus description (unless stated otherwise in the bonus description)."
                )}
              </p>
              <p>
                1h.
                {t(
                  'To use the free spins, the player needs to visit the client area, open the "Bonuses" tab and activate the free spins. They will then become available for the corresponding slot.'
                )}
              </p>
              <p>
                1i.
                {t(
                  "When using an activated bonus, the real money from the player's account is wagered first and only then the bonus money."
                )}
              </p>
              <p>
                1j.
                {t(
                  "You can claim only one bonus at a time. Deposit-related bonuses are not stacked. 1k. All deposit bonuses must be wagered x40"
                )}
              </p>
              <p>1l. {t("No bonuses are available for any of the crypto currencies.")}</p>
              <p>
                1m.
                {t(
                  `If a player is suspected of abusing a free spin promotion or hasn’t wagered the sum of deposit made to receive these free spins at least 3 (three) times (excluding bets made on table games), ${process.env.REACT_APP_BRAND_NAME} management, at its sole discretion, reserves the right to cancel all free spin bonuses and any winnings acquired from them.`
                )}
              </p>
              <p>
                1n.
                {t(
                  "If for any reason selected deposit bonus did not activate, the player must seek assistance for the customer support team before playing. If the selected deposit bonus wasn’t activated and the player spent some or all of the funds, the selected deposit bonus cannot be added manually."
                )}
              </p>
              <p>
                1o.
                {t("Comp Points may be exchanged to bonuses. General bonus terms are applied to these bonuses unless stated otherwise.")}
              </p>
            </div>
            <div className="bonus-terms-container d-flex flex-column">
              <span className="title">{t("First-deposit free spins")}</span>
              <p>
                2a.
                {t(
                  "First deposit free spins are added as a set of 25 per day for 6 days - amounting to 150 free spins in total. The first 25 free spins are added immediately after a successful activation of the bonus. The next 25 free spins are added in 24 hours, and it goes on like that for 5 days."
                )}
              </p>
              <p>2b. {t("Winnings obtained with the help of free spins have an x40 wagering requirement.")}</p>
            </div>
            <div className="bonus-terms-container d-flex flex-column">
              <span className="title">{t("Reload bonus free spins")}</span>
              <p>3a. {t("Reload bonus free spins are added as a set of 30 free spins per day for 2 days.")}</p>
              <p>
                3b.
                {t("The first 30 free spins are added immediately after a successful activation of the bonus, the next 30 - in 24 hours.")}
              </p>
              <p>3c. {t("Winnings obtained with the help of free spins have an x40 wagering requirement.")}</p>
            </div>
            <div className="bonus-terms-container d-flex flex-column">
              <span className="title">{t("Weekend Reload Bonus Terms")}</span>
              <p>4a. {t("Deposit must be made between 00-00 (UTC) on Saturday and 23-59 (UTC) on Sunday..")}</p>
              <p>4b. {t("Deposit made outside the above-mentioned time frame will not qualify for the Weekend Reload bonus.")}</p>
            </div>
            <div className="bonus-terms-container d-flex flex-column">
              <span className="title">{t("Bonus wagering terms")}</span>
              <p>5a. {t("Please mind the fact each game comes with its own wagering % -")}</p>
              <p>
                <ul>
                  <li>{t("Table games – Baccarat, Blackjack, Hi-Lo – 5% (except for games with a live dealer)")}</li>
                  <li>{t("Videopoker – 5%")}</li>
                  <li>{t("Roulette, Poker – 5% (except for games with a live dealer)")}</li>
                  <li>{t("Slots – 100% (except for the games listed below)")}</li>
                </ul>
              </p>
              <p>
                5b.
                {t(
                  "Games from jackpot and bonus buy categories are excluded from bonus promotions. The following games are excluded from the bonus promotion offer -"
                )}
                <br /> 1x2 Gaming - Craps
                <br /> Amatic - Scarab Treasure, Princess of Pearls
                <br /> BGaming - Rocket Dice, Blackjack Surrender, Plinko
                <br /> Booming - Surfin' Reels, Wombaroo
                <br /> Betsoft - Dr. Jekyll & Mr. Hyde, Fruitbat Crazy, Max Quest: Wrath of Ra, Lava Gold, Pinocchio, Spinfinity Man, Split
                Way Royal, Sugar Pop, Sugar Pop 2 - Double Dipped, Super 7 Blackjack, Take The Bank, Take Olympus, Take Santa's Shop, Tens
                or Better, The Hive!, The Mystic Hive, Three Card Rummy, Triple Edge Poker, Vip European Roulette, WhoSpunIt Plus, Zoom
                Roulette
                <br /> Endorphina - Ninja
                <br /> Epic Media - 1429 Uncharted Seas (TK), Hope Diamond (Blueprint)
                <br /> Evoplay - Fluffy Rangers, Rocket Stars
                <br /> Felix Gaming- Deep Blue, Jackbomb
                <br /> Habanero- Egyptian Dreams Deluxe, Jellyfish Flow, Knockout Football, Knockout Football Rush, London Hunter, Magic
                Oak, Presto!, Pumpkin Patch, Santa’s Village
                <br /> iSoftbet - Ambiance, Mega Boy, Roo Riches, Super Fast Hot Hot Respin, Tree of Fortune, Vegas High Roller
                <br /> Kalamba - Bangkok Dreams, Crystal Cavern, Dino Odyssey
                <br /> Mascot - Bastet and Cats
                <br /> NetEnt - Dead or Alive 2, Dead or Alive 2 Feature Buy, Devil's Delight, Lucky Angler, Reel Rush 2, Reel Steal, Robin
                Hood- Shifting Riches, Scudamore's Super Stakes, Serengeti Kings, Single Deck Blackjack Professional Series,
                <br /> Street Fighter II - The World Warrior Slot, The French Roulette, Rome - The Golden Age, The Wish Master, TXS Hold'em
                Professional Series, Wilderland
                <br /> Nolimit City - Book of Shadows
                <br /> Nucleus - Wild Cherry Blast
                <br /> NYX - 300 Shields, Jackpot Jester 200000, 1429 Uncharted Seas, Lil Devil (BTG), Royal Mint (BTG)
                <br /> OnlyPlay - Myths of Bastet
                <br /> Play'nGo - Baker's Treat, Eye of the Kraken, Golden Legend, Happy Halloween, Hugo 2, Mahjong 88, MULTIFRUIT 81,
                Pearls of India, Pimped, Rage to Riches, Royal Masquerade, Sea Hunter, Tower Quest
                <br /> Playson - Solar Temple, Solar Queen, Solar King
                <br /> Playtech - Age of the Gods - Ruler of the Seas, Shields of Rome, Storms of Ice Power Play Jackpot, Wild Lava, Savage
                Jungle, Viking Runecraft Pragmatic: 3 Kingdoms – Battle of Red Cliffs, Bronco Spirit, Cash Elevator, Dragon Kingdom - Eyes
                of Fire, Golden Beauty, Jade Butterfly, Jungle Gorilla, Queen of Gold, The Champions, Push Gaming: Jammin' Jars 2, Wild
                Swarm, Wizard Shop
                <br /> Quickfire - 3 Tiny Gods, 300 Shields, African Quest, Agent Valkyrie, Age of Conquest, Alchemy Blast, Astro
                <br /> Legends - Lyra and Erion, Art of the Heist, Augustus, Beautiful Bones, Bikini Party, Book of Oz, Bookie of Odds,
                Break Da Bank Again Respin, Castle Builder, Castle Builder II, Cool Buck, Craps, Dragon Dance, Elite of Evil - Portal of
                Gold (Gamevy), Flower Fortunes, Forsaken Kingdom, Gems Odyssey, Gems Odyssey 92, Gods Of Power, Goldaur Guardians, Golden
                Stallion, Hot Ink, Le Kaffee Bar, Lil Devil, Magic of Sahara, Medusa, Monster Blast, Peek-a-Boo - 5 Reel, Pets Go Wild,
                Rabbit in the Hat, Reel Gems, Retro Reels, Retro Reels Diamond Glitz, Retro Reels Extreme Heat, Santa Goes Wild, Scrooge,
                Sisters of Oz WOWPOT, Solar Queen (Playson), Spectacular Wheel of Wealth, Stardust, Sweet Chilli, Tomb Raider - Secret of
                the Sword, Tomb Raider, Untamed Bengal Tiger, Untamed Crowned Eagle, Untamed Giant Panda, Untamed Wolf Pack, Vampire: The
                Masquerade - Las Vegas, Village People Macho Moves, Wheel of Wealth Special Edition, Wheel of Wealth, Wild Orient, Zombie
                Hoard
                <br /> Quickspin - Skulls Up!
                <br /> Red Tiger - 5 Families, Ancients Blessing, Aztec Spins, Bombuster, Diamond Blitz, Dynamite Riches, Lucky Fridays,
                Spin Town, Three Musketeers, Reel Heist, Well of Wishes
                <br /> Relax - 3 Secret Cities (4ThePlayer), 100 Bit Dice (4ThePlayer), Book of 99, Deep Descent, Frequent Flyer,
                Hellcatraz, Kingmaker (BTG), Lil Devil (BTG), Marching Legions, Royal Mint (BTG), Slot Vegas Megaquads (BTG), Trail Blazer
                (Northernlights), Wizard Shop (Push Gaming)
                <br /> Spinomenal - Cupids Strike 2, Divine Forest, Lemur Does Vegas, Summer Splash, Mines of Gold, BlackJack
                <br /> Slotegrator - Solar King, Solar Temple
                <br /> Swintt - Egypt King
                <br /> Thunderkick - 1429 Uncharted Seas
                <br /> TrueLab - Victoria Wild
                <br /> Yggdrasil - Alchymedes, Ancient Eclipse, Cauldron, Cazino Cosmos, Dark Vortex, Dwarf Mine, Double Dragons, Football
                Glory, Holmes and the Stolen Stones, Jackpot Raiders, Johnan Legendarian, Jokerizer, Legion Hot 1, Ozwin’s Jackpots, Robin
                Sherwood Marauders, Spina Colada, The Hot Offer, The Dark Joker Rizes, The Royal Family, Tut's Twister, Vikings go to Hell,
                Vikings go Berzerk, Victoria Wild, Wicked Circus, Wolf Hunters
                <br /> Wazdan - 9 Lions, Black Horse, Black Horse Deluxe, Butterfly Lovers, Hot 777, Hot 777 Deluxe, Larry the Leprechaun,
                Reel Hero, Relic Hunters and the Book of Faith, Sonic Reels
              </p>
              <p>5c. {t("Both the bonus and the winnings will be removed once the bonus expires.")}</p>
              <p>
                5d.
                {t(
                  `Any bonus can be cancelled before you start playing it through. Otherwise, by cancelling the bonus the player accepts that all the winnings gained while playing with this bonus, if any, and the bonus amount are deducted from the player's balance. Please contact ${process.env.REACT_APP_BRAND_NAME} support service to find out more about cancelling your bonus.`
                )}
              </p>
              <p>
                5e.
                {t(
                  "A player can change currency only after the first stage of the welcome bonus has been completed. For instance, if the player already made a deposit of $/€/20 as the first stage of the welcome bonus, they can later use a different currency for the second deposit."
                )}
              </p>
              <p>
                5f.
                {t(
                  "Players can request a withdrawal of their deposit prior to meeting the wagering requirements. However, in this case the bonus and any resulting winnings will be forfeited."
                )}
              </p>
            </div>
            <div className="bonus-terms-container d-flex flex-column">
              <span className="title">{t("Additional terms")}</span>
              <p>
                6a.
                {t(
                  `The management of ${process.env.REACT_APP_BRAND_NAME} reserves the right to withhold or seize any bonuses or winnings gained as a result of fraudulent or otherwise unfair practices.`
                )}
              </p>
              <p>
                {t(
                  `Bonuses offered by ${process.env.REACT_APP_BRAND_NAME} are intended for genuine recreational players only. The bonuses are not intended to give away free money to players classified as “bonus hunters” or “bonus abusers”.. `
                )}
              </p>
              <p>
                {t(
                  `The ${process.env.REACT_APP_BRAND_NAME} management will review all player accounts and classify them at their discretion. In the event a Player is classified as a “bonus hunter” or “bonus abuser”, all winnings and bonuses will be voided.`
                )}
              </p>
              <p>
                6b.
                {t(
                  `At ${process.env.REACT_APP_BRAND_NAME} it's forbidden to abuse the bonus offers available (customer bonus ratio (deposits - bonuses) is more than 50%). If any such cases come to light, the casino reserves the right to seize any winnings gained as a result of abusing the bonus offers and disable the option of using any bonuses for that account in future.`
                )}
              </p>
              <p>
                6c.
                {t(
                  "Minimal risk bets on any games (i.e. betting in proportions on different outcomes in the same hand to create “action” with minimal risk) do not qualify for completing the wagering requirement. Examples of minimal risk bets include betting on red and black simultaneously in Roulette, and betting on player and banker simultaneously in Baccarat. Players found to be adopting these practices risk having their bonus and any resulting winnings confiscated."
                )}
              </p>
              <p>
                6d.
                {t(
                  "It's forbidden to postpone any playing rounds, including free spins and bonus rounds, for the time when you no longer need to play the bonus through and/or make new deposit(s)."
                )}
              </p>
              <p>
                6e.
                {t(
                  "The use of bonus funds purely to progress through the bonus stages is prohibited. For example when bonus or cash funds are used purely to progress through the bonus stages (e.g. collecting 9 out of 10 coins to reach that bonus feature) and then final stages (e.g. playing to collect the final coin to reach 10 out of 10 coins to reach the bonus feature) completed with cash bets when bonus funds have been forfeited, lost or wagering met and converted to cash. All the winnings gained during that play may be considered void."
                )}
              </p>
              <p>
                6f.
                {t(
                  "Players from the following countries are not eligible for no-deposit free spin bonuses- Korea, Democratic People's Republic of (KP), Iran, Islamic Republic of (IR), Algeria (DZ), Ecuador (EC), Indonesia (ID), Myanmar (MM), Afghanistan (AF), Angola (AO), Cambodia (KH), Guyana (GY), Iraq (IQ), Kuwait (KW), Lao People's Democratic Republic (LA), Namibia (NA), Nicaragua (NI), Pakistan (PK), Panama (PA), Papua New Guinea (PG), Sudan (SD), Lithuania (LT), Latvia (LV), Syrian Arab Republic (SY), Uganda (UG), Yemen (YE), Zimbabwe (ZW), Israel (IL), Hong Kong (HK), Philippines (PH), Taiwan (TW), Canada (CA), Singapore (SG), United Kingdom (GB), United States (US), Denmark (DK), Italy (IT), Belgium (BE), Spain (ES), France (FR), Korea, Republic of (KR), Romania (RO), Bulgaria (BG), Estonia (EE), Portugal (PT), Mexico (MX), Ukraine (UA), Malaysia (MY), Indonesia (ID), Bangladesh (BD), Albania (AL), Georgia (GE), Thailand (TH), Nepal (NP), United Arab Emirates (AE), Romania (RO), Bulgaria (BG), Hungary (HU), Poland (PL), India (IN), Pakistan (PK), Philippines (PH), Portugal (PT), Slovakia (SK), Kazakhstan (KZ), Vietnam (VN), Bahrain (BH), Egypt (EG), Iran, Islamic Republic of (IR), Iraq (IQ), Kuwait (KW), Oman (OM), Palestine, State of (PS), Syrian Arab Republic (SY), Yemen (YE), Mongolia (MN), Algeria (DZ), Angola (AO), Benin (BJ), Botswana (BW), Burundi (BI), Cameroon (CM), Cape Verde (CV), Chad (TD), Comoros (KM), Djibouti (DJ), Equatorial Guinea (GQ), Eritrea (ER), Ethiopia (ET), Gambia (GM), Ghana (GH), Guinea (GN), Guinea-Bissau (GW), Côte d'Ivoire (CI), Kenya (KE), Lesotho (LS), Liberia (LR), Moldova, Republic of (MD), Madagascar (MG), Malawi (MW), Mali (ML), Mauritania (MR), Mauritius (MU), Morocco (MA), Mozambique (MZ), Namibia (NA), Niger (NE), Nigeria (NG), Rwanda (RW), Sao Tome and Principe (ST), Senegal (SN), Seychelles (SC), Sierra Leone (SL), Somalia (SO), South Sudan (SS), Sudan (SD), Swaziland (SZ), Tanzania, United Republic of (TZ), Togo (TG), Tunisia (TN), Uganda (UG), Zambia (ZM), Zimbabwe (ZW), Greece (GR), Hungary (HU), Mauritius (MU), Slovenia (SI), Croatia (HR), Bosnia and Herzegovina (BA), Macedonia, Republic of (MK), Montenegro (ME), and Serbia (RS)"
                )}
              </p>
              <p>6g. {t("Sign-up free spins will be credited within 24 hours from the moment of registration.")}</p>
              <p>6h. {t(`${process.env.REACT_APP_BRAND_NAME} reserves the right to change these terms at its discretion any time.`)}</p>
              <p>
                6i.
                {t(
                  "Bonus is automatically cancelled upon active balance reaching amount of 0.05 USD, 0.05 EUR, 0.05 NOK, 0.05 AUD, 0.05 JPY, 0.05 NZD, 0.05 CAD, 0.05 PLN, 3.5 HUF, 0.000001 BTC, 0.00001 BCH, 0.00001 ETH, 0.0005 LTC, 10 DOG, 0.05 USDT or less.* *This term only applies balance tied to bonus, i.e. deposit + bonus or only bonus in case of no deposit bonus, and doesn't apply funds on player's balance gained from other deposits or bonuses."
                )}
              </p>
              <p>
                6j.
                {t(
                  "Max bet limit (5 EUR) includes bets doubling after a game round has been completed, bonus rounds (purchased within the game)."
                )}
              </p>
            </div>
            <div className="bonus-terms-container d-flex flex-column">
              <span className="title">{t("The Wheel of Fortune")}</span>
              <p>7a. {t("The Wheel of Fortune runs once a week, on Thursday.")}</p>
              <p>7b. {t("To activate the Wheel of Fortune, your deposit must be at least 30 EUR / 30 USD.")}</p>
              <p>7c. {t("The bonus code GOLD can be activated once a day between 00-00 and 23-59 UTC.")}</p>
              <p>7d. {t("Free spins winnings are subject to a wagering requirement of x40.")}</p>
              <p>7e. {t("All money rewards should be wagered x1.")}</p>
              <p>7f. {t("Physical prize can be redeemed for its cash equivale")}</p>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};
